// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"80":"158c86e1","227":"adec1276","918":"36850b6d","962":"6d7719e2","997":"1e394927"}[chunkId] + ".css";
};